module.exports = __webpack_public_path__ + "static/media/iconStudentsActive.3df17385.svg";